export const tableHeader = [
  'File Name',
  'Uploaded By',
  'Uploaded On',
  'Validation Status'
]
